import { useEffect, useMemo, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { PageHeader, Empty } from "@/components/PageHeader";
import { NewsCard } from "@/components/NewsCard";
import { api } from "@/lib/api";

const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const ALL = "tutti";

const Filtri = ({ items, anno, mese, setAnno, setMese }) => {
  const anni = useMemo(() => [...new Set(items.map((n) => n.data.slice(0, 4)))].sort().reverse(), [items]);
  const mesi = useMemo(
    () => [...new Set(items.filter((n) => anno === ALL || n.data.startsWith(anno)).map((n) => Number(n.data.slice(5, 7))))].sort((a, b) => a - b),
    [items, anno],
  );
  return (
    <div className="flex flex-wrap items-center gap-3 mb-8" data-testid="news-filters">
      <Select value={anno} onValueChange={(v) => { setAnno(v); setMese(ALL); }}>
        <SelectTrigger className="w-40 bg-white" data-testid="news-filter-year"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL}>Tutti gli anni</SelectItem>
          {anni.map((a) => <SelectItem key={a} value={a} data-testid={`news-filter-year-${a}`}>{a}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={mese} onValueChange={setMese}>
        <SelectTrigger className="w-44 bg-white" data-testid="news-filter-month"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL}>Tutti i mesi</SelectItem>
          {mesi.map((m) => <SelectItem key={m} value={String(m)} data-testid={`news-filter-month-${m}`}>{MESI[m - 1]}</SelectItem>)}
        </SelectContent>
      </Select>
      {(anno !== ALL || mese !== ALL) && (
        <Button variant="ghost" size="sm" onClick={() => { setAnno(ALL); setMese(ALL); }} data-testid="news-filter-reset">Azzera filtri</Button>
      )}
    </div>
  );
};

export default function News() {
  const [items, setItems] = useState(null);
  const [anno, setAnno] = useState(ALL);
  const [mese, setMese] = useState(ALL);
  useEffect(() => {
    api.get("/notizie", { params: { limit: 200 } }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  const shown = (items || []).filter((n) => (anno === ALL || n.data.startsWith(anno)) && (mese === ALL || Number(n.data.slice(5, 7)) === Number(mese)));
  return (
    <div>
      <PageHeader kicker="Associazione e classi" title="News" />
      {items && items.length > 0 && <Filtri items={items} anno={anno} mese={mese} setAnno={setAnno} setMese={setMese} />}
      {items && items.length > 0 && <p className="text-sm text-muted-foreground -mt-4 mb-6" data-testid="news-count">{shown.length} news</p>}
      {items && shown.length === 0 && <Empty data-testid="news-empty">Nessuna notizia per il periodo selezionato.</Empty>}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="news-list">
        {shown.map((n, i) => <NewsCard key={n.id} n={n} delay={Math.min(i, 8) * 50} />)}
      </div>
    </div>
  );
}
